// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyASwj6QJC541qtbKrjPzYzX-OHkT_cPdUc",
  authDomain: "healhub-a0378.firebaseapp.com",
  databaseURL: "https://healhub-a0378-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "healhub-a0378",
  storageBucket: "healhub-a0378.appspot.com",
  messagingSenderId: "556977742383",
  appId: "1:556977742383:web:978184a2a027269982dcda"
};

// Initialize Firebase app (UNCHANGED)
const app = initializeApp(firebaseConfig);

// ✅ FIX: safer Firestore initialization to prevent INTERNAL ASSERTION FAILED error
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
  useFetchStreams: false,
});

// Other services (UNCHANGED)
export const auth = getAuth(app);
export const realtimeDB = getDatabase(app);
export const storage = getStorage(app);